import { Badge, Box, Container, IconButton, Toolbar } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PersonIcon from '@mui/icons-material/Person';
import MuiAppBar from '@mui/material/AppBar';
import CoopervassLogoTransparent from '../../assets/techpines-background-transparent.png';
import React, { useContext, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { NotificacoesContext } from '../../contexts/NotificacoesContext';
import { useNavigate } from 'react-router-dom';
import MenuUser from './MenuUser';
import useMobileScreen from '../../lib/useMobileScreen';
import { usePermissionsContext } from '../../contexts/PermissionsContext';

export default function AppBar() {

    const navigate = useNavigate();
    const telaMobile = useMobileScreen()
    const { procurarPermissoes } = usePermissionsContext()
    const { getUserData, logout } = useContext(AuthContext);
    const { quantidadeTarefas } = useContext(NotificacoesContext);

    let userData = getUserData()

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [itemExibido, setItemExibido] = useState<string | null>(null);

    //Funções Manipuladoras
    const handleMenu = (event: React.MouseEvent<HTMLElement>, item: string) => {
        setItemExibido(item)
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setItemExibido(null)
        setAnchorEl(null)
    };

    const handleLogout = () => {
        logout()
    }
    //

    return (
        <MuiAppBar position="static">
            <Toolbar style={{ margin: '0px 20px' }}>
                <Container sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Box display="flex" gap={1} alignItems="center" width="15%">
                        <Box onClick={() => {navigate('/dashboard'); procurarPermissoes()}} style={{ cursor: 'pointer' }}>
                            <img style={{ width: telaMobile ? 140 : 190 }} src={CoopervassLogoTransparent} alt='' />
                        </Box>
                    </Box>

                    <Box display="flex" justifyContent="flex-end" alignItems="center" width="10%" >
                        <IconButton color="inherit" onClick={() => navigate('/tarefas')}>
                            <Badge badgeContent={quantidadeTarefas} color="error">
                                <NotificationsIcon />
                            </Badge>
                        </IconButton>
                        
                        <IconButton
                            color="inherit"
                            style={{ marginLeft: 12 }}
                            onClick={(e) => handleMenu(e, "MenuUser")}
                        >
                            <PersonIcon />
                        </IconButton>
                        {
                            itemExibido === "MenuUser" &&
                            <MenuUser
                                {...{ anchorEl, userData, handleClose, handleLogout }}
                            />
                        }
                    </Box>
                </Container>
            </Toolbar>

        </MuiAppBar>
    )
}